<template>
  <div class="login">
    <div class="container">
      <img src="../assets/imgs/logo.png" alt="" />
      <!-- <h1>kissu</h1> -->
      <el-form v-model="form" class="form">
        <div>
          <el-input class="input" placeholder="账号" v-model="form.username">
            <template slot="prepend"
              ><i class="iconfont icon-yonghu"></i
            ></template>
          </el-input>
        </div>
        <div>
          <el-input
            class="input"
            type="password"
            placeholder="密码"
            v-model="form.password"
          >
            <template slot="prepend"
              ><i class="iconfont icon-icon_password"></i
            ></template>
          </el-input>
        </div>
        <el-button
          class="button"
          type="primary"
          @click="login"
          :loading="loading"
          >登录</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */

import Md5 from 'md5'
import { type } from '@/store/index'

export default {
  data () {
    return {
      form: {
        username: '',
        password: '',
        env: type == 1 ? 'test' : 'production',
        testEnv: localStorage.getItem('baseAPI') || null
      },
      loading: false
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {},
  computed: {},
  methods: {
    changeEnv(value) {
      console.log(value);
      this.form.testEnv = value
      localStorage.setItem('baseAPI', this.form.testEnv)
      window.location.reload()
    },
    login () {
      this.loading = true
      let date = new Date()
      let curTime = date.getTime().toString()
      
      // 更新 baseAPI
      localStorage.setItem('baseAPI', this.form.testEnv)
      
      this.$axios({
        method: 'POST',
        url: this.$store.getters.path.login,
        withCredentials: true,
        data: {
          time: curTime,
          username: this.form.username,
          key: Md5(curTime + Md5(this.form.password))
        }
      }).then(
        res => {
          if (res.data.code === 0) {
            // sessionStorage.setItem('username', this.form.username)
            // sessionStorage.setItem('userLevel', res.data.data.level)
            // sessionStorage.setItem('token', res.data.data.token)
            window.$cookies.set('username_kissu', this.form.username)
            window.$cookies.set('userLevel_kissu', res.data.data.level)
            window.$cookies.set('token_kissu', res.data.data.token)
            this.$store.state.token = res.data.data.token
            this.$store.state.username = this.form.username
            // 菜单
            this.$store.state.auths = res.data.data.auths
            // sessionStorage.setItem('auths', JSON.stringify(res.data.data.auths))
           localStorage.setItem(
              'auths_kissu',
              JSON.stringify(res.data.data.auths)
            )
            // 更新渠道号
            let channels = [{ label: 'all', value: 'all' }]
            res.data.data.channels.map(e => {
              channels.push({
                label: e.name,
                value: e.value
              })
            })
            this.$store.state.channels = channels
            // sessionStorage.setItem('channels', JSON.stringify(channels))
            localStorage.setItem('channels_kissu', JSON.stringify(channels))
            this.loading = false
            this.$router.push('/')
          } else {
            this.loading = false
            this.$alert(res.data.msg, '请重新登录', {
              confirmButtonText: '确定'
            })
          }
        },
        err => {
          window.console.log('error. ' + err)
          this.$alert('登录异常', '', {
            confirmButtonText: '确定'
          })
        }
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/stylus/variable.styl';
@import '../assets/icon/iconfont.css';

.login {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: $color-blue;

  .container {
    position: fixed;
    left: 50%;
    top: 200px;
    width: 500px;
    height: 450px;
    margin-left: -250px;
    text-align: center;
    border-radius: 5px;
    background-color: $color-white;

    img {
      width: 100px;
      height: 100px;
      margin-top: 50px;
    }

    h1 {
      font-size: $font-size-large;
      color: $color-blue;
    }

    form {
      width: 300px;
      margin: 0 auto;

      .env-select {
        width: 300px;
        margin-top: 20px;
      }

      .input {
        margin-top: 20px;
        border-radius: 5px;
        border: 1px solid $color-blue-light;
      }

      .button {
        margin-top: 20px;
        width: 300px;
      }
    }
  }
}
</style>
